import Swiper, { A11y, Navigation } from 'swiper';
import { createMediaQueryList, getBreakpoint } from '../utils/_breakpoints';

class mPdCarrouselScroll extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
        this.mqlDesktop = createMediaQueryList('md');
    }

    connectedCallback() {
        this.initSlider();
    }

    disconnectedCallback() {}

    initSlider() {
        const bpDesktop = getBreakpoint('md').minWidth.replace('px', '');

        this.slider = new Swiper(this, {
            modules: [A11y, Navigation],
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 40,
            allowTouchMove: true,
            resistanceRatio: 0,
            threshold: 5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                [bpDesktop]: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                },
            },
        });

        this.mqlDesktop.addEventListener('change', this.updateLayout.bind(this));
        this.updateLayout();
    }

    updateLayout() {
        const isDesktop = this.mqlDesktop.matches;

        if (isDesktop) {
            this.slider.disable();
            if (this.slider.wrapperEl) {
                this.slider.wrapperEl.style.transform = '';
            }
        } else {
            this.slider.enable();
        }
    }
}

customElements.define('m-pd-carrousel-scroll', mPdCarrouselScroll, {
    extends: 'div',
});
